import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../../../components/loader/loader';

const Transaction = (props) => {

    const { api, userData, settingData, auxAccountData, rateToMainCurrency, rateMainToSecondaryCurrency, currencyData } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);


    const { transactions, setTransactions, table, title, refreshTable, size, footer, idRow } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const today = new Date().toISOString().split('T')[0];

    const mainCurrency = currencyData.find(item => item.id === settingData.mainCurrencyId);
    const secondaryCurrency = currencyData.find(item => item.id === settingData.secondaryCurrencyId);

    // Account Options
    const accountOptions = auxAccountData?.map(item => ({
        value: item.id,
        label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
        invoices: item.journalVouchers,
    }));
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
        callback(filteredOptions);
    };


    // Currency Options
    const currencyOptions = currencyData?.map(item => ({
        value: item.id,
        label: item.code,
        rate: item.rate,
        isMultiply: item.isMultiply,
    }))



    const transactionsItem = {
        accountId: null,
        currencyId: '',
        details: '',
        debit: 0,
        credit: 0,
        totalDebit: 0,
        totalCredit: 0,
        secondaryTotalDebit: 0,
        secondaryTotalCredit: 0,
        rate: 0,
    };

    // Add new row
    const handleAddRow = () => {
        setTransactions([...transactions, transactionsItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event) => {
        event.preventDefault()
        if (transactions.length > 2) {
            const updatedRows = transactions.slice(0, -1);
            setTransactions(updatedRows);
        } else {
            toast.error('you need at least two transactions')
        }
    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedtransactions = [...transactions];

        if (field == 'account') {
            updatedtransactions[index].accountId = value.value;
            updatedtransactions[index].currencyId = mainCurrency?.id;
            updatedtransactions[index].rate = mainCurrency?.rate;

        } else if (field == 'currencyId') {
            updatedtransactions[index].currencyId = value.value;
            updatedtransactions[index].rate = value.rate;

        } else if (field == 'debit') {
            updatedtransactions[index].debit = value;
            updatedtransactions[index].totalDebit = value * updatedtransactions[index].rate;

        } else if (field == 'credit') {
            updatedtransactions[index].credit = value;
            updatedtransactions[index].totalCredit = value * updatedtransactions[index].rate;

        } else if (field == 'totalDebit') {
            updatedtransactions[index].totalDebit = value;
            updatedtransactions[index].debit = value / updatedtransactions[index].rate;

        } else if (field == 'totalCredit') {
            updatedtransactions[index].totalCredit = value;
            updatedtransactions[index].credit = value / updatedtransactions[index].rate;
        }
        else if (field == 'details') {
            updatedtransactions[index].details = value;
        }

        const selectedCurrency = currencyData.find(item => item.id === updatedtransactions[index].currencyId);
        updatedtransactions[index].totalDebit = rateToMainCurrency(selectedCurrency, updatedtransactions[index].debit);
        updatedtransactions[index].totalCredit = rateToMainCurrency(selectedCurrency, updatedtransactions[index].credit);

        
        updatedtransactions[index].secondaryTotalDebit = rateMainToSecondaryCurrency(updatedtransactions[index].totalDebit);
        updatedtransactions[index].secondaryTotalCredit = rateMainToSecondaryCurrency(updatedtransactions[index].totalCredit);

        setTransactions(updatedtransactions);
    }







    return (
        <>
            {transactions.map((row, index) => (
                <div key={index} style={{ marginTop: '-31px' }}>
                    {/* Labels */}
                    {index === 0 && (
                        <Row className="mb-3 g-0" style={{ backgroundColor: 'white' }}>
                            <Form.Group as={Col} md={2}>
                                <Form.Label>Account</Form.Label>
                            </Form.Group>


                            <Form.Group as={Col} md={1}>
                                <Form.Label>Currency</Form.Label>
                            </Form.Group>

                            <Form.Group as={Col} md={3}>
                                <Form.Label>Details</Form.Label>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>Debit</Form.Label>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>Credit</Form.Label>
                            </Form.Group>

                            <Form.Group as={Col} md={1}>
                                <Form.Label>Rate</Form.Label>
                            </Form.Group>


                            <Form.Group as={Col} >
                                <Form.Label>Debit {mainCurrency.code}</Form.Label>
                            </Form.Group>


                            <Form.Group as={Col} >
                                <Form.Label>Credit {mainCurrency.code}</Form.Label>
                            </Form.Group>

                            {secondaryCurrency &&
                                <Form.Group as={Col} >
                                    <Form.Label>Debit {secondaryCurrency?.code}</Form.Label>
                                </Form.Group>
                            }

                            {secondaryCurrency &&
                                <Form.Group as={Col} >
                                    <Form.Label>Credit {secondaryCurrency?.code}</Form.Label>
                                </Form.Group>
                            }

                        </Row>

                    )}

                    {/* Account */}
                    <Row className="mb-3 g-0" style={{ marginTop: '-10px' }}>
                        <Form.Group as={Col} md={2}>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadAccountOptions}
                                defaultOptions={[]}
                                onChange={(e) => handleRowChange(index, e, 'account')}
                                value={accountOptions.find(option => option.value === transactions[index].accountId) || []}
                                noOptionsMessage={() => 'type to view'}
                                required
                            />
                        </Form.Group>


                        {/* Currency */}
                        <Form.Group as={Col} md={1}>
                            <Select
                                options={currencyOptions}
                                isSearchable={true}
                                placeholder="Select"
                                onChange={(e) => handleRowChange(index, e, 'currencyId')}
                                value={currencyOptions?.find(option => option.value === transactions[index].currencyId) || []}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Form.Group>



                        {/* Details */}
                        <Form.Group as={Col} md={3}>
                            <Form.Control as="textarea" rows={1}
                                value={transactions[index].details}
                                onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Form.Group>


                        {/* debit */}
                        <Form.Group as={Col} >
                            <Form.Control type="number" min={0} step='any' value={transactions[index].debit}
                                style={{ backgroundColor: '#FBF2E1' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'debit')}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Form.Group>

                        {/* credit */}
                        <Form.Group as={Col} >
                            <Form.Control type="number" min={0} step='any' value={transactions[index].credit}
                                style={{ backgroundColor: '#FBF2E1' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'credit')}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Form.Group>


                        {/* rate */}
                        <Form.Group as={Col} md={1}>
                            <Form.Control type="number" min={0} step='any' value={transactions[index].rate}
                                onChange={(e) => handleRowChange(index, e.target.value, 'rate')}
                                required
                                disabled={true}
                            />
                        </Form.Group>


                        {/* total debit */}
                        <Form.Group as={Col} >
                            <Form.Control type="number" min={0} step='any' value={transactions[index].totalDebit}
                                style={{ backgroundColor: '#D5E4D6' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'totalDebit')}
                                required
                                disabled={true}
                            />
                        </Form.Group>


                        {/* total credit */}
                        <Form.Group as={Col}  >
                            <Form.Control type="number" name="total" id="total" value={transactions[index].totalCredit}
                                style={{ backgroundColor: '#D5E4D6' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'totalCredit')}
                                required
                                disabled={true}
                            />
                        </Form.Group>



                        {/* sec total debit */}
                        {secondaryCurrency &&
                            <Form.Group as={Col} >
                                <Form.Control type="number" min={0} step='any' value={transactions[index].secondaryTotalDebit}
                                    style={{ backgroundColor: '#f1f9ff' }}
                                    required
                                    disabled={true}
                                />
                            </Form.Group>
                        }

                        {/* Sec total credit */}
                        {secondaryCurrency &&
                            <Form.Group as={Col}  >
                                <Form.Control type="number" name="total" id="total" value={transactions[index].secondaryTotalCredit}
                                    style={{ backgroundColor: '#f1f9ff' }}
                                    required
                                    disabled={true}
                                />
                            </Form.Group>
                        }
                    </Row>



                    <Row key={index + 100} className="mb-3">
                        {index === transactions.length - 1 && (
                            <Form.Group
                                as={Col}
                                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}
                            >
                                <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                                <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />

                            </Form.Group>
                        )}
                    </Row>
                </div>
            ))
            }
        </>
    )
}


export default Transaction;